import _regeneratorRuntime from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
export var FeatureFlagClient =
/*#__PURE__*/
function () {
  function FeatureFlagClient(baseUrl) {
    _classCallCheck(this, FeatureFlagClient);

    this.cache = new Map();
    this.cacheTimeout = 10 * 60 * 1000; // 10 minutes

    this.authToken = null; // Track in-flight requests to prevent duplicate calls

    this.pendingRequests = new Map();
    this.baseUrl = baseUrl;
  }
  /**
   * Set the JWT auth token for API requests
   */


  _createClass(FeatureFlagClient, [{
    key: "setAuthToken",
    value: function setAuthToken(token) {
      this.authToken = token;
    }
    /**
     * Get the current auth token
     */

  }, {
    key: "getAuthToken",
    value: function getAuthToken() {
      return this.authToken;
    }
    /**
     * Get headers with authorization if token is set
     */

  }, {
    key: "getHeaders",
    value: function getHeaders() {
      var headers = {
        'Content-Type': 'application/json'
      };

      if (this.authToken) {
        headers['Authorization'] = this.authToken;
      }

      return headers;
    }
  }, {
    key: "getFromCache",
    value: function getFromCache(key) {
      var entry = this.cache.get(key);

      if (!entry) {
        return null;
      }

      var age = Date.now() - entry.timestamp;

      if (age > this.cacheTimeout) {
        this.cache.delete(key);
        return null;
      }

      return entry.evaluation;
    } // Public method to get cached value synchronously (for initial state)

  }, {
    key: "getCachedValue",
    value: function getCachedValue(key) {
      return this.getFromCache(key);
    }
  }, {
    key: "setCache",
    value: function setCache(key, evaluation) {
      this.cache.set(key, {
        evaluation: evaluation,
        timestamp: Date.now()
      });
    }
  }, {
    key: "evaluateFlags",
    value: function () {
      var _evaluateFlags = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(keys) {
        var cached, uncachedKeys, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _key, cachedEval, evaluations, _i, _uncachedKeys, key, evaluation, allEvaluations, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _loop, _iterator2, _step2;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Check cache first for all keys
                cached = [];
                uncachedKeys = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 5;

                for (_iterator = keys[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  _key = _step.value;
                  cachedEval = this.getFromCache(_key);

                  if (cachedEval) {
                    cached.push(cachedEval);
                  } else {
                    uncachedKeys.push(_key);
                  }
                } // If all keys are cached, return cached results


                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](5);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 13:
                _context.prev = 13;
                _context.prev = 14;

                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }

              case 16:
                _context.prev = 16;

                if (!_didIteratorError) {
                  _context.next = 19;
                  break;
                }

                throw _iteratorError;

              case 19:
                return _context.finish(16);

              case 20:
                return _context.finish(13);

              case 21:
                if (!(uncachedKeys.length === 0)) {
                  _context.next = 23;
                  break;
                }

                return _context.abrupt("return", cached);

              case 23:
                _context.prev = 23;
                // Fetch each uncached flag individually using GET
                evaluations = [];
                _i = 0, _uncachedKeys = uncachedKeys;

              case 26:
                if (!(_i < _uncachedKeys.length)) {
                  _context.next = 35;
                  break;
                }

                key = _uncachedKeys[_i];
                _context.next = 30;
                return this.evaluateFlag(key);

              case 30:
                evaluation = _context.sent;

                if (evaluation) {
                  evaluations.push(evaluation);
                }

              case 32:
                _i++;
                _context.next = 26;
                break;

              case 35:
                // Combine cached and new results, maintaining key order
                allEvaluations = [];
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 39;

                _loop = function _loop() {
                  var key = _step2.value;
                  var found = [].concat(cached, evaluations).find(function (e) {
                    return e.key === key;
                  });

                  if (found) {
                    allEvaluations.push(found);
                  } else {
                    // If not found, return disabled default
                    allEvaluations.push({
                      key: key,
                      enabled: false,
                      reason: 'disabled'
                    });
                  }
                };

                for (_iterator2 = keys[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  _loop();
                }

                _context.next = 48;
                break;

              case 44:
                _context.prev = 44;
                _context.t1 = _context["catch"](39);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t1;

              case 48:
                _context.prev = 48;
                _context.prev = 49;

                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                  _iterator2.return();
                }

              case 51:
                _context.prev = 51;

                if (!_didIteratorError2) {
                  _context.next = 54;
                  break;
                }

                throw _iteratorError2;

              case 54:
                return _context.finish(51);

              case 55:
                return _context.finish(48);

              case 56:
                return _context.abrupt("return", allEvaluations);

              case 59:
                _context.prev = 59;
                _context.t2 = _context["catch"](23);
                console.error('[FeatureFlagClient] Error evaluating feature flags:', _context.t2); // Return cached results if available, otherwise default disabled state

                if (!(cached.length > 0)) {
                  _context.next = 64;
                  break;
                }

                return _context.abrupt("return", cached);

              case 64:
                return _context.abrupt("return", keys.map(function (key) {
                  return {
                    key: key,
                    enabled: false,
                    reason: 'disabled'
                  };
                }));

              case 65:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 9, 13, 21], [14,, 16, 20], [23, 59], [39, 44, 48, 56], [49,, 51, 55]]);
      }));

      function evaluateFlags(_x) {
        return _evaluateFlags.apply(this, arguments);
      }

      return evaluateFlags;
    }()
  }, {
    key: "evaluateFlag",
    value: function () {
      var _evaluateFlag = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(key) {
        var cached, pending, requestPromise, result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // Check cache first
                cached = this.getFromCache(key);

                if (!cached) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return", cached);

              case 3:
                // Check if there's already a pending request for this key
                pending = this.pendingRequests.get(key);

                if (!pending) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt("return", pending);

              case 6:
                // Create the request promise
                requestPromise = this.fetchFlag(key);
                this.pendingRequests.set(key, requestPromise);
                _context2.prev = 8;
                _context2.next = 11;
                return requestPromise;

              case 11:
                result = _context2.sent;
                return _context2.abrupt("return", result);

              case 13:
                _context2.prev = 13;
                // Clean up pending request
                this.pendingRequests.delete(key);
                return _context2.finish(13);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[8,, 13, 16]]);
      }));

      function evaluateFlag(_x2) {
        return _evaluateFlag.apply(this, arguments);
      }

      return evaluateFlag;
    }()
  }, {
    key: "fetchFlag",
    value: function () {
      var _fetchFlag = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(key) {
        var response, data, evaluation;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return fetch("".concat(this.baseUrl, "/feature-flags/").concat(key), {
                  method: 'GET',
                  headers: this.getHeaders()
                });

              case 3:
                response = _context3.sent;

                if (response.ok) {
                  _context3.next = 8;
                  break;
                }

                if (!(response.status === 404)) {
                  _context3.next = 7;
                  break;
                }

                return _context3.abrupt("return", null);

              case 7:
                throw new Error("HTTP error! status: ".concat(response.status));

              case 8:
                _context3.next = 10;
                return response.json();

              case 10:
                data = _context3.sent;
                // Server returns { key, enabled } - convert to evaluation format
                evaluation = {
                  key: data.key,
                  enabled: data.enabled,
                  reason: data.enabled ? 'enabled' : 'disabled'
                }; // Cache the result

                this.setCache(key, evaluation);
                return _context3.abrupt("return", evaluation);

              case 16:
                _context3.prev = 16;
                _context3.t0 = _context3["catch"](0);
                console.error("[FeatureFlagClient] Error evaluating flag ".concat(key, ":"), _context3.t0);
                return _context3.abrupt("return", null);

              case 20:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 16]]);
      }));

      function fetchFlag(_x3) {
        return _fetchFlag.apply(this, arguments);
      }

      return fetchFlag;
    }()
  }, {
    key: "getAllFlags",
    value: function () {
      var _getAllFlags = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var response, data;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return fetch("".concat(this.baseUrl, "/feature-flags"), {
                  method: 'GET',
                  headers: this.getHeaders()
                });

              case 3:
                response = _context4.sent;

                if (response.ok) {
                  _context4.next = 6;
                  break;
                }

                throw new Error("HTTP error! status: ".concat(response.status));

              case 6:
                _context4.next = 8;
                return response.json();

              case 8:
                data = _context4.sent;
                return _context4.abrupt("return", data.flags || []);

              case 12:
                _context4.prev = 12;
                _context4.t0 = _context4["catch"](0);
                console.error('[FeatureFlagClient] Error fetching feature flags:', _context4.t0);
                return _context4.abrupt("return", []);

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 12]]);
      }));

      function getAllFlags() {
        return _getAllFlags.apply(this, arguments);
      }

      return getAllFlags;
    }()
  }]);

  return FeatureFlagClient;
}();
/**
 * Create a feature flag client instance
 */

export function createFeatureFlagClient(baseUrl) {
  return new FeatureFlagClient(baseUrl);
}